import React, { useEffect } from 'react'

function Faqs(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner center-bg"
          style={{ backgroundImage: `url('images/faq-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="partner-banner-content">
                  <h1 className="ml10">
                    <span className="text-wrapper">
                      <span className="letters">RoadJockey FAQ</span>
                    </span>
                  </h1>
                  <text className="ml12">
                    <span className="text-wrapper">
                      <span className="letters">
                        From time to time, we get repeat questions and
                        inquiries. We want to ensure all your needs are being
                        met, so we have gathered together our more frequent
                        responses for your convenience.
                      </span>
                    </span>
                  </text>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2 text-left">
                <div className="faq-content">
                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq1"
                    >
                      <h4>How do I place an order?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq1" className="collapse">
                      <div className="div_faq_a">
                        Download the RoadJockey app, sign up for a free account,
                        then search for your favorite foods. Once you select a
                        specific set of items from the menu, you add them to
                        your cart and checkout. Our app will notify the
                        restaurant or grocer, and a local Roadie will pick up
                        then deliver your order. It’s that easy!
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq2"
                    >
                      <h4>How do I pay?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq2" className="collapse">
                      <div className="div_faq_a">
                        RoadJockey uses credit card payment online for ease of
                        ordering and less contact.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq3"
                    >
                      <h4>Is this safe?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq3" className="collapse">
                      <div className="div_faq_a">
                        Yes! RoadJockey uses all the latest security and
                        verification credentials to ensure every one of your
                        transactions is protected. We do not share information
                        with anyone outside of the functions of our application.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq4"
                    >
                      <h4>When will the charge show up on my card?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq4" className="collapse">
                      <div className="div_faq_a">
                        Once you checkout, a charge is initiated to your credit
                        card.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq5"
                    >
                      <h4>Will I get a receipt?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq5" className="collapse">
                      <div className="div_faq_a">
                        Yes. Not only will we provide you with a receipt in the
                        app, but we also send an email to your registered
                        address. If you cannot find that email, be sure to
                        double-check your spam folder.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq6"
                    >
                      <h4>Can I change or cancel an order?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq6" className="collapse">
                      <div className="div_faq_a">
                        You can, but we ask that you call us directly so we can
                        facilitate that need between you, our Roadie, and our
                        Food Partners.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq7"
                    >
                      <h4>Can I track my order?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq7" className="collapse">
                      <div className="div_faq_a">
                        You can track your order by using the roadie&apos;s
                        location on the map.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq8"
                    >
                      <h4>My order is wrong, now what?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq8" className="collapse">
                      <div className="div_faq_a">
                        Start by reaching out to the restaurant or grocer to
                        ensure there wasn’t a problem. Then please reach out to
                        our support staff so we can provide you with a solution.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq9"
                    >
                      <h4>How long will my order take?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq9" className="collapse">
                      <div className="div_faq_a">
                        Our great Roadies will deliver as quickly as possible
                        depending on traffic, time to complete your order at the
                        restaurant, and distance. We always strive for a timely
                        response to your orders.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq10"
                    >
                      <h4>How long will my order take?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq10" className="collapse">
                      <div className="div_faq_a">
                        Our great Roadies will deliver as quickly as possible
                        depending on traffic, time to complete your order at the
                        restaurant, and distance. We always strive for a timely
                        response to your orders.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq11"
                    >
                      <h4>Do I have to present to receive my order?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq11" className="collapse">
                      <div className="div_faq_a">
                        We request that someone be present at your delivery
                        location to receive the order from our Roadie and verify
                        the order has been completed.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq12"
                    >
                      <h4>How do I leave a review?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq12" className="collapse">
                      <div className="div_faq_a">
                        Once your order is complete, you’ll be able to leave a
                        review about our Food Partners. We are always excited to
                        hear your positive feedback about how well they
                        performed.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq13"
                    >
                      <h4>Do you track my order history?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq13" className="collapse">
                      <div className="div_faq_a">
                        Yes. RoadJockey provides each of our members with a
                        comprehensive list of their recent orders, purchases,
                        and completed deliveries. We want to make sure you can
                        always order again from those places you liked the most.
                      </div>
                    </div>
                  </div>

                  <div className="div_faq">
                    <div
                      className="div_faq_q collapsed"
                      data-toggle="collapse"
                      data-target="#faq15"
                    >
                      <h4>What if I have more questions?</h4>
                      <img
                        className="img_collapse_closed"
                        src="images/faq_page/dropdown-collapsed.svg"
                      />
                      <img
                        className="img_collapse_opened"
                        src="images/faq_page/dropdown.svg"
                      />
                    </div>
                    <div id="faq15" className="collapse">
                      <div className="div_faq_a">
                        Please feel free to use our contact form to send any
                        other questions, concerns, or inquiries you may have.
                        You can also get communicate with our social media ages
                        we are always happy to respond.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Faqs
